import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteHostsSelected, hideHostModalDelete
} from 'store/Host/actions';
import ModalConfirmation from 'Common/Components/ModalConfirmation';
import { selectHostsSelected, selectIsFetching, selectShowDeleteConfirmation } from 'store/Host/selectors';

const DeleteConfirmationModal = () => {
  const dispatch = useDispatch();
  const hostsSelected = useSelector(selectHostsSelected);
  const showDeleteConfirmation = useSelector(selectShowDeleteConfirmation);
  const isFetching = useSelector(selectIsFetching);

  return (
    <ModalConfirmation
      show={ showDeleteConfirmation }
      handleSubmit={ () => dispatch(deleteHostsSelected()) }
      handleClose={ () => dispatch(hideHostModalDelete()) }
      entity="host"
      count={ hostsSelected.length }
      loading={ isFetching }
    />
  );
};

export default DeleteConfirmationModal;
